import { Component,OnInit} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { PreturnoService } from '../../api/preturno.service';

@Component({
	selector: 'app-jefes',
	templateUrl: './jefes.component.html',
	styleUrls: ['./jefes.component.css']
})
export class JefesComponent implements OnInit {

	persona_seleccionada:any
	jefe_seleccionada:any
	jefe_cedula:any
	mostrar
	filtrar_jefe
	verificar=false
	personas_escogidas=[]
	personas_acargo=[]
	personas_acargo_value=[]
	personas_acargo_value2=[]

	constructor(private preturno:PreturnoService,private Translate:TranslateService) { }

	ngOnInit() {

		this.mostrarusuario()

	}

	mostrarusuario(){

		this.preturno.usuario().subscribe((data:any)=>{
			
			this.personas_acargo=data

			 this.personas_acargo_value2=this.personas_acargo.map(item=>{
				return {
					"value":item.cedula+","+item.nombre,
					"nombre":item.nombre,
					"cedula":item.cedula
				}
			}) 
			
		})

	}

	agregarpersona(){

		let value = this.persona_seleccionada.split(',');

		this.personas_escogidas.push(
			{
				"cedula":value[0],
				"nombre":value[1]
			}
			)
		
			this.personas_acargo_value = this.personas_acargo_value.filter((item) => item.cedula !== value[0])
		
	}

	borrarpersona(cedula){

		this.personas_acargo.forEach(element => {
			
			if(element.cedula===cedula){
				this.personas_acargo_value.push(
					 {
						"value":element.cedula+","+element.nombre,
						"nombre":element.nombre,
						"cedula":element.cedula
					}
				)
			}

		});

		this.personas_escogidas = this.personas_escogidas.filter((item) => item.cedula !== cedula)


	}

	guardar_jefe(){

		let personas_jefe=[]

		console.log(this.jefe_seleccionada)
		personas_jefe=this.personas_escogidas.map(item=>item.cedula)
		console.log(personas_jefe)

		this.preturno.guardarjefespersonas(personas_jefe,this.jefe_seleccionada).subscribe()

	}

	cambio(cedula_jefe){

		this.personas_escogidas=[]
		
		this.preturno.mostrarjefespersonas(cedula_jefe).subscribe((data:any)=>{

			let arraycedulas=data.map(item=>item.documento)
		
			this.personas_acargo.forEach((datos:any) => {
				let quitar=arraycedulas.indexOf(datos.cedula)
				if (quitar==-1) {
					this.personas_acargo_value.push({
						"value":datos.cedula+","+datos.nombre,
						"nombre":datos.nombre,
						"cedula":datos.cedula
					})
				}
			});
			
			data.map(item=>{
				this.personas_escogidas.push(
					{
						"cedula":item.documento,
						"nombre":item.persona
					}
					)
			})
		})

	}

	buscarjefe(){

		this.preturno.mostrarjefespersonas(this.jefe_cedula).subscribe((data:any)=>{
			this.mostrar=data	
			this.verificar=true
		})

	}

	eliminar(id){

		Swal.fire({

			title: this.Translate.instant('Estas Seguro?'),
			text:  this.Translate.instant('Quieres borrar la asignacion de esta persona'),
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: this.Translate.instant('Si')
	  
		  }).then((result) => {
			if (result.isConfirmed) {
			 
				this.preturno.borrarPersona(id).subscribe(data=>{
	
					this.preturno.mostrarjefespersonas(this.jefe_cedula).subscribe(data=>{
						this.mostrar=data
						this.verificar=true
					})
	
				  Swal.fire(
					this.Translate.instant('Borrado con exito'),
					this.Translate.instant('La persona fue removida de este jefe'),
					'error'
				  )
	
				})
	
			}
		  })

	}

	filtrarjefefuncion(filtrar_jefe){

		this.preturno.filtrarJefe(filtrar_jefe).subscribe((data:any)=>{
		
			this.personas_acargo=data
	
				 this.personas_acargo_value2=this.personas_acargo.map(item=>{
					return {
						"value":item.documento+","+item.user_name,
						"nombre":item.user_name,
						"cedula":item.documento
					}
				}) 
			
		 })

	}

	filtrarjefe(){

		this.personas_acargo=[]
		this.personas_acargo_value2=[]

	 	this.filtrarjefefuncion(this.filtrar_jefe)

	}

	onChange(filtro) {
		
		if (filtro=="") {
			
			this.filtrarjefefuncion("")

		}

	}

}